import "./Forbidden.scss"
import { FaHammer } from "react-icons/fa";

function Forbidden() {
  return (
    <div className="construction">
      <FaHammer />
      <h1>Page under construction</h1>
    </div>
  );
}

export default Forbidden;
